import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery} from './base.query';
import { UpdateProfileResponse } from '../../types/user.type';

export enum AuthTags {
    UPDATE_PROFILE = 'update_auth'
}

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery:baseQuery ,
  tagTypes: Object.values(AuthTags),
  endpoints: (builder) => ({
    getEmailedCode: builder.mutation<{data: UpdateProfileResponse}, string>({
      query: (email) => ({
        url: 'Users/EmailVerificationCode?email='+email,
        method: 'GET',
      }),
    }),
  }),
});

export const { 
  useGetEmailedCodeMutation
} = authApi;

export default authApi;
